import { styled, Theme } from '@mui/material';

import { coreThemeColors } from '@youscience/theme';
import { CoreButton, CoreDialog, CoreDialogTitle } from '@youscience/core';

export const sxStyles = {
  footer: (theme: Theme) => ({
    padding: '1.5rem',
    borderTop: `1px solid ${theme.palette.grey['300']}`,
  }),
};

export const StyledDialog = styled(CoreDialog)(() => ({
  '.MuiPaper-root': {
    maxWidth: '720px',
    width: '100%',
    borderRadius: '12px',
  },
}));

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  ...theme.typography.h4,
  maxWidth: '540px',
  margin: '0 auto',
  padding: '2rem 1.5rem 1.25rem',
  textAlign: 'center',
}));

export const StyledCancelBtn = styled('button')(() => ({
  font: 'inherit',
  margin: 0,
  background: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '94px',
  height: '48px',
  padding: '0.5rem',
  borderRadius: '50px',
  color: coreThemeColors.secondary.main,
  transition: 'background-color 0.5s',
  border: `1px solid ${coreThemeColors.secondary.main}`,

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: coreThemeColors.secondary.outlinedHoverBackground,
  },
}));

export const StyledContinueBtn = styled(CoreButton)(() => ({
  width: '94px',
  height: '48px',
  backgroundColor: coreThemeColors.secondary.main,
  borderRadius: '50px',
  transition: 'background-color 0.5s',

  '&:hover': {
    backgroundColor: coreThemeColors.secondary.dark,
  },
}));
